/** ScrollSpy
 * Based on: https://blog.devgenius.io/diy-scrollspy-4f1c270cafaf
 * Example: https://codesandbox.io/s/reverent-surf-nkzzv
 */
import { useEffect, useCallback } from 'react';

import useGetHeaderHeight from './useGetHeaderHeight';

export interface ScrollSpyProps {
  handleScroll?: any;
}

export const ScrollSpy = ({ handleScroll }: ScrollSpyProps) => {
  const headerHeight = useGetHeaderHeight();

  const isInViewPort = useCallback((entry: IntersectionObserverEntry, offset = 0) => {
    const rect = entry.boundingClientRect;
    return rect.top - 1 <= 0 + offset && rect.bottom >= 0 + offset;
  }, []);

  useEffect(() => {
    if (typeof document === 'undefined') return;
    const scrollables = document.querySelectorAll('[data-scrollspy]');

    if (!scrollables || scrollables.length === 0) return;

    const observers: Array<IntersectionObserver> = [];

    scrollables.forEach((scrollable) => {
      if (!scrollable) return;
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (handleScroll && typeof handleScroll === 'function') {
              handleScroll(entry, isInViewPort(entry, headerHeight));
            }
          });
        },
        {
          root: null,
          rootMargin: `${-headerHeight}px 0px 200% 0px`,
          threshold: [0.0, 1.0]
        }
      );
      observer.observe(scrollable);

      observers.push(observer);
    });

    return () => {
      observers.forEach((observer) => {
        if (observer && typeof observer.disconnect === 'function') {
          observer.disconnect();
        }
      });
    };
  }, [handleScroll, headerHeight]);

  return null;
};
